import { z } from "zod";

import { InvoiceSchema } from "@entities/invoice";

export const OrderLineSchema = z.object({
  id: z.number(),
  note: z.string().optional(),
  itemId: z.number().or(z.null()),
  itemName: z.string().or(z.null()),
  unitsQuantity: z.number(),
  orderedQuantity: z.number(),
});

export const OrderSchema = z.object({
  id: z.number(),
  note: z.string(),
  poNumber: z.string(),
  creationTime: z.string(),
  isResolved: z.boolean(),
  isConfirmed: z.boolean(),
  docNumber: z.string(),
  customerId: z.number(),
  trackingNumbers: z.array(z.string()),
  linesValue: z.array(OrderLineSchema),
  relatedInvoices: z.array(InvoiceSchema),
  deliveryExpectedAt: z.string().nullable(),
});

export type OrderLine = z.infer<typeof OrderLineSchema>;
export type Order = z.infer<typeof OrderSchema>;
